module.exports = __webpack_public_path__ + "img/AA526C_EAA6C9_DC88AF_D17BA0-256px.76090571.png";